export default __webpack_public_path__ + "static/media/clock-icon.0f3e1521.svg";